import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" モデルが正しい向きになるように軸を合わせてください ")
const _hoisted_2 = { class: "d-flex align-center flex-grow-1" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("軸をリセット")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { width: "300" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_subtitle, { class: "d-block" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coordinates, (prop, idx) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: idx,
              class: "d-flex"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_text_field, {
                    class: "mr-2",
                    reverse: "",
                    "model-value": _ctx.rad2deg(_ctx.rotation[prop]),
                    label: prop,
                    density: "compact",
                    "hide-details": "false",
                    min: 0,
                    max: 360,
                    prefix: "°",
                    "onUpdate:modelValue": (v) => _ctx.input(idx, v)
                  }, null, 8, ["model-value", "label", "onUpdate:modelValue"]),
                  _createVNode(_component_v_slider, {
                    style: {"width":"100px"},
                    min: 0,
                    max: 360,
                    "thumb-size": "10",
                    "hide-details": "false",
                    "model-value": _ctx.rad2deg(_ctx.rotation[prop]),
                    "onUpdate:modelValue": (v) => _ctx.input(idx, v)
                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_v_list_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "outlined",
                onClick: _ctx.reset
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}